import axios from 'axios';
import router from '../router';

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-type': 'application/json',
    Authorization: localStorage.getItem('token'),
  }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('userCode');
    localStorage.removeItem('role_name');
    localStorage.removeItem('userPermission');
    localStorage.removeItem('userName');
    localStorage.removeItem('serviceType');
    router.push({ name: 'login' });
  } else {
    return Promise.reject(error);
  }
});

export default http;
